/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './topics-panel.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../shared/svg-icon/svg-icon.component.ngfactory';
import * as i5 from '../../../../../app/shared/svg-icon/svg-icon.component';
import * as i6 from '../../../../../app/shared/translations/translate.directive';
import * as i7 from '../../../../../app/shared/translations/translations.service';
import * as i8 from '../../../../../app/shared/settings.service';
import * as i9 from '../../../../../app/help-center/front/topics-panel/topics-panel.component';
import * as i10 from '../../../../../app/help-center/shared/hc-urls.service';
const styles_TopicsPanelComponent:any[] = [i0.styles];
export const RenderType_TopicsPanelComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_TopicsPanelComponent,data:{}});
function View_TopicsPanelComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'a',[['class',
      'category']],[[2,'active',(null as any)],[1,'target',0],[8,'href',4]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'svg-icon',[['name','folder-open']],(null as any),
      (null as any),(null as any),i4.View_SvgIconComponent_0,i4.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i5.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class','category-name']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_3:any = _co.urls.getCategoryLink(_v.context.$implicit);
        _ck(_v,1,0,currVal_3);
        const currVal_4:any = 'folder-open';
        _ck(_v,4,0,currVal_4);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.category.id == _v.context.$implicit.id);
        const currVal_1:any = i1.ɵnov(_v,1).target;
        const currVal_2:any = i1.ɵnov(_v,1).href;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
        const currVal_5:any = _v.context.$implicit.name;
        _ck(_v,7,0,currVal_5);
      });
}
export function View_TopicsPanelComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'title'],['trans','']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(4341760,(null as any),0,i6.TranslateDirective,[i1.ElementRef,
      i7.Translations,i8.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
      ['Related Content'])),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'div',[['class','categories-list']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TopicsPanelComponent_1)),i1.ɵdid(802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i9.TopicsPanelComponent = _v.component;
    const currVal_0:any = _co.topics;
    _ck(_v,7,0,currVal_0);
  },(null as any));
}
export function View_TopicsPanelComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'topics-panel',
      ([] as any[]),(null as any),(null as any),(null as any),View_TopicsPanelComponent_0,
      RenderType_TopicsPanelComponent)),i1.ɵdid(114688,(null as any),0,i9.TopicsPanelComponent,
      [i10.HcUrls],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TopicsPanelComponentNgFactory:i1.ComponentFactory<i9.TopicsPanelComponent> = i1.ɵccf('topics-panel',
    i9.TopicsPanelComponent,View_TopicsPanelComponent_Host_0,{category:'category'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9mcm9udC90b3BpY3MtcGFuZWwvdG9waWNzLXBhbmVsLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2hlbHAtY2VudGVyL2Zyb250L3RvcGljcy1wYW5lbC90b3BpY3MtcGFuZWwuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9mcm9udC90b3BpY3MtcGFuZWwvdG9waWNzLXBhbmVsLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9mcm9udC90b3BpY3MtcGFuZWwvdG9waWNzLXBhbmVsLmNvbXBvbmVudC50cy5Ub3BpY3NQYW5lbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJ0aXRsZVwiIHRyYW5zPlJlbGF0ZWQgQ29udGVudDwvZGl2PlxyXG5cclxuPGRpdiBjbGFzcz1cImNhdGVnb3JpZXMtbGlzdFwiPlxyXG4gICAgPGEgY2xhc3M9XCJjYXRlZ29yeVwiICpuZ0Zvcj1cImxldCB0b3BpYyBvZiB0b3BpY3NcIiBbY2xhc3MuYWN0aXZlXT1cImNhdGVnb3J5LmlkID09IHRvcGljLmlkXCIgW3JvdXRlckxpbmtdPVwidXJscy5nZXRDYXRlZ29yeUxpbmsodG9waWMpXCI+XHJcbiAgICAgICAgPHN2Zy1pY29uIG5hbWU9XCJmb2xkZXItb3BlblwiPjwvc3ZnLWljb24+XHJcbiAgICAgICAgPHNwYW4gY2xhc3M9XCJjYXRlZ29yeS1uYW1lXCI+e3t0b3BpYy5uYW1lfX08L3NwYW4+XHJcbiAgICA8L2E+XHJcbjwvZGl2PiIsIjx0b3BpY3MtcGFuZWw+PC90b3BpY3MtcGFuZWw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDR0k7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO1VBQUE7TUFBQTtJQUFBO0lBQUE7RUFBQSx1Q0FBQTtNQUFBO01BQUEsZUFBcUksK0NBQ2pJO01BQUE7TUFBQTthQUFBO1VBQUEsaUNBQXdDO01BQ3hDO1VBQUE7TUFBNEIsd0NBQXFCOzs7UUFGcUM7UUFBMUYsV0FBMEYsU0FBMUY7UUFDYztRQUFWLFdBQVUsU0FBVjs7O1FBRDZDO1FBQWpEO1FBQUE7UUFBQSxXQUFpRCxVQUFqRCxtQkFBQTtRQUVnQztRQUFBOzs7O29CQUxwQztNQUFBO01BQUEsdUJBQUE7d0NBQUEsK0JBQXlCO01BQUEsc0JBQXFCLHlDQUU5QztNQUFBO01BQUEsMERBQTZCO01BQUEsYUFDekI7TUFBQSxxQ0FBQTt1Q0FBQSx5Q0FHSTthQUFBOztJQUhnQjtJQUFwQixXQUFvQixTQUFwQjs7OztvQkNISjtNQUFBO3FDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/help-center/front/topics-panel/topics-panel.component.ngfactory.ts